import React, { useState } from "react";
import "./faq.css"; // Ensure this CSS file contains the styles for responsiveness and animations

const Faq = () => {
  // State to handle active FAQ
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "Do I need prior experience to join?",
      answer:
        "No prior experience is necessary! We welcome individuals of all skill levels. Beginners are encouraged to participate in recreational leagues where they can learn and improve their skills in a supportive environment",
    },
    {
      question: "Can I join multiple teams or sports?",
      answer:
        "Yes, members can join multiple teams across different sports. However, please note that you may only compete in one team per league (e.g., one open or women’s team) to ensure fair play and scheduling",
    },
    {
      question: "How often do practices and games occur?",
      answer:
        "Practices typically occur twice a week, with games scheduled on weekends or weekday evenings depending on the sport. The exact schedule may vary by team and season, so it's best to check with your specific team for details",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      {/* Header Section */}
      <div className="faq-header">
        <h1>FAQ's</h1>
        <div className="notification-icon">
          <span className="notification-bell">🔔</span>
          <span className="notification-count">3</span>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="faq-section">
        {faqData.map((faq, index) => (
          <div key={index} className="faq-item">
            <div
              className={`faq-question ${
                activeIndex === index ? "active" : ""
              }`}
              onClick={() => toggleFaq(index)}
            >
              {faq.question}
              <span className="toggle-icon">
                {activeIndex === index ? "-" : "+"}
              </span>
            </div>
            <div
              className={`faq-answer ${
                activeIndex === index ? "open" : "closed"
              }`}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
